import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, DialogOverlay, DialogOverlayActions, FlowGrid, Image, Paragraph, TextArea } from '@fs/zion-ui'
import AttachFlowOnboardingImage from '../../../../assets/attachFlowOnboarding.png'

// Cap the free-text reason before it's forwarded verbatim to splunk.log, for log hygiene.
const REASON_MAX_LENGTH = 500

export default function TurnOffNamesExperienceDialog({ overlay, onTurnOff }) {
  const [t] = useTranslation()
  const [reason, setReason] = useState('')

  const handleTurnOff = () => {
    onTurnOff(reason)
    setReason('')
    overlay.close()
  }

  const handleCancel = () => {
    setReason('')
    overlay.close()
  }

  return (
    <DialogOverlay
      {...overlay}
      title={t('turnOffNamesExperienceDialog.title', 'Turn off the updated look for the Names feature')}
      footer={
        <DialogOverlayActions>
          <Button
            onClick={handleCancel}
            linkName="turn-off-names-experience-cancel"
            data-testid="turn-off-cancel"
            color="gray"
          >
            {t('turnOffNamesExperienceDialog.cancel', 'Cancel')}
          </Button>
          <Button
            emphasis="high"
            onClick={handleTurnOff}
            linkName="turn-off-names-experience-confirm"
            data-testid="turn-off-confirm"
            color="gray"
          >
            {t('turnOffNamesExperienceDialog.confirm', 'Turn off')}
          </Button>
        </DialogOverlayActions>
      }
    >
      <FlowGrid columnCount={1} orientation="vertical">
        <Image src={AttachFlowOnboardingImage} height={270} aria-hidden="true" />
        <Paragraph centered>
          {t(
            'turnOffNamesExperienceDialog.description',
            "You're about to go back to the previous way of viewing and editing names on a record."
          )}
        </Paragraph>
        <TextArea
          label={t('turnOffNamesExperienceDialog.reasonLabel', 'Why are you turning it off?')}
          placeholder={t('turnOffNamesExperienceDialog.reasonPlaceholder', 'Optional')}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
          maxLength={REASON_MAX_LENGTH}
        />
      </FlowGrid>
    </DialogOverlay>
  )
}
